<template>
  <v-dialog v-model="dialog" :fullscreen="$vuetify.breakpoint.smAndDown" content-class="configuration-dialog" persistent max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" class="register-ingestion-btn" color="success">
        <v-icon left>add</v-icon>{{$t('Button.CreateConfiguration')}}
      </v-btn>
    </template>
    <v-flex>
      <v-card flat dark>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Create Configuration</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click.native="close()" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
    </v-flex>
    <v-flex style="overflow: auto;">
      <v-card flat>
        <v-card-text>
          <component :is="formComponent" ref="configurationComponent" @validate="onValidate" @setValidated="setValidated" @submit="onSubmit" @block="onBlock" />
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex>
      <v-card style="border-top: 1px solid #dddddd;">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" :disabled="!isValidated || isBlocked" :loading="isSaving" @click="submit()">
            <v-icon left>done</v-icon>{{$t('Button.Save')}}
          </v-btn>
          <v-btn color="secondary" outline @click="close()">{{$t('Button.Cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-dialog>
</template>

<script>
  import ErrorMessages from '../Helpers/ErrorMessages'

  export default {
    data: () => ({
      dialog: false,
      isValidated: false,
      isBlocked: false,
      isSaving: false,
    }),
    computed: {
      currentService() {
        return this.$store.getters['serviceconfigurations/currentService']
      },
      formComponent() {
        return this.$store.getters['serviceconfigurations/formComponent']
      },
    },
    methods: {
      setValidated(value) {
        this.isValidated = value
      },
      async onValidate(validationModel) {
        try {
          let response = await this.$store.dispatch('serviceconfigurations/validateConfiguration', {
            service: this.currentService,
            payload: validationModel,
          })

          this.$refs.configurationComponent.setValidateResponse(response.data)
        } catch (error) {
          console.log(error)
          this.$refs.configurationComponent.invalidate(ErrorMessages.fatalErrorMessageLabel, ErrorMessages
            .fatalErrorMessageLong)
        }
      },
      onBlock(result) {
        this.isBlocked = result
      },
      close() {
        this.reset()
        this.dialog = false
      },
      async onSubmit(configuration) {
        this.isSaving = true
        try {
          await this.$store.dispatch('serviceconfigurations/addConfiguration', {
            configuration,
            service: this.currentService,
          })

          this.$emit('fetchConfigurations')
          this.close()
        } catch (error) {
          console.log(error)
          this.isSaving = false
          this.$refs.configurationComponent.invalidate(ErrorMessages.fatalErrorMessageLabel, ErrorMessages
            .fatalErrorMessageLong)
        }
      },
      submit() {
        this.$refs.configurationComponent.submit()
      },
      reset() {
        setTimeout(function() {
          this.isSaving = false
          this.isValidated = false
          if(this.$refs.configurationComponent) {
            this.$refs.configurationComponent.resetForm()
          }          
        }.bind(this), 500)
      },
      setStateSaving(value) {
        this.isSaving = value
        this.isBlocked = value
      },
    },
  }
</script>

<style scoped>
  .v-dialog--fullscreen>.v-card {
    min-height: 85px !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card {
    min-height: Calc(100% - 85px) !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card .v-card__text {
    padding: 0px !important;
  }
</style>
<style>
  .configuration-dialog {
    display: flex;
    flex-direction: column;
  }
</style>